import React from 'react';
import PropTypes from 'prop-types';
import {get} from 'lodash';
import className from 'classnames';
import axios from 'axios';

import {
  useCheckIds,
} from '../hooks';

import {
  CSRF_TOKEN,
  requestCallback,
} from '../lib/helpers';

import DotTooltip from './DotTooltip';

const ModeratorsListTable = ({
  data = [],
  type
}) => {
  const {
    checkIds,
    renderCheckBox, renderCheckBoxForCheckAll,
  } = useCheckIds({
    data,
  })

  const bulkDelete = () => {
    requestCallback(axios.delete(`/${gon.currentProvider}/api/bulk/${type}s`, {
      data: {
        ids: checkIds,
        authenticity_token: CSRF_TOKEN
      }
    }))
  }

  return (
    <React.Fragment>
      <div className='TableChecker'>
        {renderCheckBoxForCheckAll()}

        <div className='TableChecker__right'>
          <a
            onClick={bulkDelete}
            className='TableChecker__right__a TableChecker__right__a--trash'
            disabled={get(checkIds, 'length', 0) == 0}
          />
        </div>
      </div>

      <div className='Table Table--moderators-list'>
        {(() => {
          const columnHeaders = [
            '', 'ID', 'User ID', 'Username', 'Manage',
          ]

          return (
            <div className='Table__row'>
              {columnHeaders.map((header, key) => (
                <div
                  key={key}
                  className='Table__col Table__col--th'
                >
                  {header}
                </div>
              ))}
            </div>
          )
        })()}

        {data.map((x, i) => (
          <div
            className={className('Table__row', {
              'Table__row--active': checkIds.includes(x.id),
            })}
            key={i}
          >
            <div className='Table__col'>
              {renderCheckBox(x)}
            </div>

            <div className='Table__col'>{get(x, 'id')}</div>
            <div className='Table__col'>
              <DotTooltip
                user={x.user}
              />
            </div>
            <div className='Table__col'>{get(x, 'user.username')}</div>

            <div className='Table__col'>
              <div className='Table__controls'>
                <a
                  className='Table__controls__a Table__controls__a--logs'
                  href={`/${gon.currentProvider}/logs?loggable_id=${get(x, 'id')}&loggable_type=${type}`}
                />

                <a
                  className='Table__controls__a Table__controls__a--trash'
                  onClick={() => {
                    requestCallback(axios.delete(`/${gon.currentProvider}/api/${type}s/${get(x, 'id')}`, {
                      data: {
                        authenticity_token: CSRF_TOKEN
                      }
                    }))
                  }}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </React.Fragment>
  );
}

ModeratorsListTable.propTypes = {
};

export default ModeratorsListTable;
